<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/epigraph#epi">Epigraph</a></p>
<p class="toc"><a href="#/xhtml/ack#ack">Acknowledgements</a></p>
<p class="toc-bot"><a href="#/xhtml/glossary#glo">Glossary of Terms</a></p>
<p class="toc"><a href="#/xhtml/prologue#pro">Prologue: Facing the Angel</a></p>
<p class="toc">1. <a href="#/xhtml/chapter1#ch1">The Garden of Eden</a></p>
<p class="toc">2. <span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">The World Turned Upside Down</span></p>
<p class="toc">3. <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Occupation</span></p>
<p class="toc">4. <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Day Turned to Night</span></p>
<p class="toc">5. <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Descent into Hell</span></p>
<p class="toc">6. <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Razor’s Edge</span></p>
<p class="toc">7. <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">The Rampe</span></p>
<p class="toc">8. <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">The Prince’s Mine</span></p>
<p class="toc">9. <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Death March</span></p>
<p class="toc">10. <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Cold Comfort Farm</span></p>
<p class="toc">11. <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">The <span class="epub-i">Cap Arcona</span></span></p>
<p class="toc">12. <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Liberation</span></p>
<p class="toc">13. <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">The Land of Milk and Honey</span></p>
<p class="toc">14. <span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">A Kind of Justice? A Kind of Peace?</span></p>
<p class="toc-bot">15. <span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Return to Eden</span></p>
<p class="toc"><span href="#/xhtml/photo1#ph1" title="Link target outside of Sample">Photographs</span></p>
<p class="toc"><span href="#/xhtml/note#note" title="Link target outside of Sample">Notes on Sources</span></p>
<p class="toc"><span href="#/xhtml/bib#bib" title="Link target outside of Sample">Further Reading</span></p>
<p class="toc"><span href="#/xhtml/app#app" title="Link target outside of Sample">Appendix</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor#abt" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5eef1014